// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5685';



export const API_ENDPOINTS = {
  // Inquiries
  createInquiry: `${API_BASE_URL}/admin/inquiry/create`,

  // Quotes
  createQuote: `${API_BASE_URL}/admin/quotes/create`,

  // Banners
  banners: `${API_BASE_URL}/admin/banner/get-banners`,

  // Services (note: singular "service" in URL)
  services: `${API_BASE_URL}/admin/service/get-services`,
  getService: (id) => `${API_BASE_URL}/admin/service/get-service/${id}`,

  // Projects (using gallery endpoint from backend)
  projects: `${API_BASE_URL}/admin/gallery/all`,
  getProject: (id) => `${API_BASE_URL}/admin/gallery/${id}`,

  // Blogs
  blogs: `${API_BASE_URL}/admin/blogs`,
  getBlog: (slug) => `${API_BASE_URL}/admin/blogs/slug/${slug}`,

  // Testimonials
  testimonials: `${API_BASE_URL}/admin/testimonials`,

  // Collaborators
  collaborators: `${API_BASE_URL}/admin/collaborators/all`,

  // Gallery
  gallery: `${API_BASE_URL}/admin/gallery/all`,


    // Live Gallery
  livegallery: `${API_BASE_URL}/admin/livegallery/all`,


  // CMS
  cms: `${API_BASE_URL}/admin/cms/get-content`,
  getCMS: (slug) => `${API_BASE_URL}/admin/cms/get-content/${slug}`,

  // Site Settings
  siteSettings: `${API_BASE_URL}/admin/settings`,

  // Site Info
  siteInfo: `${API_BASE_URL}/admin/site-info`,


   // Newslteer Subscriptions
  newsletterSubscribe: `${API_BASE_URL}/admin/newsletter/subscribe`,

  // News
  news: `${API_BASE_URL}/admin/news`,
};

export default API_BASE_URL;
